// Override Cart.updates.product to prevent hiding oldFinalPrice in B2B mode
const originalProductUpdate = Cart.updates.product;

Cart.updates.product = function ($holder, data) {
    // Call the original function first
    originalProductUpdate.call(this, $holder, data);

    // For B2B, always show old prices (don't hide them)
    if (window.isB2b == "1") {
        if (data.old_price) {
            $('[data-element="cartItem"]')
                .filter('[data-type="oldPrice"]')
                .filter('[data-id="' + data.id + '"]')
                .show();

            $('[data-element="cartItem"]')
                .filter('[data-type="oldPriceVat"]')
                .filter('[data-id="' + data.id + '"]')
                .show();
        }

        if (data.old_total) {
            $('[data-element="cartItem"]')
                .filter('[data-type="oldFinalPrice"]')
                .filter('[data-id="' + data.id + '"]')
                .show();

            $('[data-element="cartItem"]')
                .filter('[data-type="oldFinalPriceVat"]')
                .filter('[data-id="' + data.id + '"]')
                .show();
        }
    }
};
